import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard, Autoplay } from 'swiper/modules';
const $ = window.jQuery;

const $DOM = {};
let gridSwiper;
let desktop = window.matchMedia('(min-width: 1024px)');
let init = false;

const domCache = () => {
    $DOM.container = $(".grid-slider");
    if (!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".grid-slider__swiper");
}

const initSwiper = () => {
    if(desktop.matches) {
        if (!init) return;

        init = false;
        gridSwiper.destroy()
    }
    else{
        if (init) return;

        init = true;
        gridSwiper = new Swiper($DOM.swiperContainer[0], {
            modules: [Navigation, Pagination, A11y, Keyboard, Autoplay],
            init: false,
            slidesPerView: 1,
            speed: 750,
            preventClicksPropagation: false,
            roundLengths: true,
            loop: true,
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
                clickable: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            breakpoints: {
                769: {
                    slidesPerView: 2,
                },
            },
            watchOverflow: true
        });

        gridSwiper.on("init", onInit);
        gridSwiper.on("slideChange", onSlideChange);
        gridSwiper.init();
    }
}

const onInit = () => {
    $DOM.swiperContainer.addClass("is-init");
}

const onSlideChange = () => {

}

const gridSlider = {
    init: () => {
        domCache();
        if (!$DOM.container.length) {
            return;
        }
        window.addEventListener('load', function() {
            initSwiper();
        });
        window.addEventListener('resize', function() {
            initSwiper();
        });
    }
};

export default gridSlider;